import { apiClient } from "./client";
import { User, ApiResponse } from "../types/index";

export interface LoginResponse {
  user: User;
  access_token: string;
  refresh_token?: string;
}

export interface RefreshTokenResponse {
  success: boolean;
  message: string;
}

const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

export class AuthAPI {
  static async login(): Promise<ApiResponse<LoginResponse>> {
    // For OAuth2/Auth0 flow, redirect to backend login endpoint
    // 現在のURLをstateパラメータとして渡し、認証後に元のページに戻れるようにする
    const currentUrl = window.location.pathname + window.location.search;
    const stateParam = encodeURIComponent(currentUrl);
    window.location.href = `${API_BASE_URL}/auth/login?prompt=login&state=${stateParam}`;
    return { success: true };
  }

  static async logout(): Promise<ApiResponse<void>> {
    try {
      window.location.href = `${API_BASE_URL}/auth/logout`;
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: "Logout failed",
      };
    }
  }

  static async refreshToken(): Promise<ApiResponse<RefreshTokenResponse>> {
    return apiClient.post<RefreshTokenResponse>("/auth/refresh_token");
  }

  static async getCurrentUser(): Promise<ApiResponse<User>> {
    try {
      // Use the dedicated /auth/me endpoint to get real user information
      const response = await apiClient.get<any>("/auth/me");
      console.log("🔍 Raw /auth/me response:", response);

      // Backend returns { success: true, data: { id, name, email, iconUrl } }
      // But apiClient.get wraps it again, so we get { success: true, data: { success: true, data: { ... } } }
      if (response.success && response.data) {
        if (response.data.success && response.data.data) {
          // Handle double-nested response
          return {
            success: true,
            data: response.data.data,
          };
        } else if (response.data.id) {
          // Handle direct user data
          return {
            success: true,
            data: response.data,
          };
        }
      }

      return {
        success: false,
        error: "Invalid response format",
      };
    } catch (error) {
      return {
        success: false,
        error: "Not authenticated",
      };
    }
  }

  static async checkAuthStatus(): Promise<boolean> {
    try {
      console.log("🔍 Checking auth status with /auth/me...");
      // Check if user has valid session by trying to access protected endpoint
      const response = await apiClient.get<any>("/auth/me");
      console.log("📊 Auth check response:", response);

      // Handle nested response structure
      if (response.success && response.data) {
        // If response.data has success property, it's a nested response
        const data = response.data as any;
        if (data.success !== undefined) {
          return data.success !== false;
        }
      }

      return response.success;
    } catch (error) {
      console.log("❌ Auth check failed:", error);
      return false;
    }
  }
}

export default AuthAPI;

